import React from 'react'
import { PillButton } from '../actions/PillButton'

export interface SessionRecoveryBannerProps {
  restoredCount: number
  storageWarning?: boolean
  onDismiss: () => void
  onClear: () => void
}

export const SessionRecoveryBanner: React.FC<SessionRecoveryBannerProps> = ({
  restoredCount,
  storageWarning = false,
  onDismiss,
  onClear,
}) => {
  if (restoredCount === 0 && !storageWarning) return null

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '12px',
        padding: '12px 20px',
        borderRadius: '16px',
        background: storageWarning
          ? 'rgba(255, 176, 32, 0.08)'
          : 'rgba(56, 191, 255, 0.06)',
        border: `1px solid ${
          storageWarning ? 'rgba(255, 176, 32, 0.25)' : 'rgba(56, 191, 255, 0.2)'
        }`,
        backdropFilter: 'blur(16px)',
        marginBottom: '20px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <i
          className={`pi ${storageWarning ? 'pi-exclamation-triangle' : 'pi-history'}`}
          style={{
            fontSize: '16px',
            color: storageWarning ? 'var(--c-warning-500, #ffb020)' : 'var(--c-accent-electric, #38BFFF)',
          }}
        />
        <div style={{ fontSize: '13.5px', color: 'rgba(255, 255, 255, 0.85)' }}>
          {storageWarning ? (
            <span>
              <strong>Alerta de almacenamiento:</strong> La cuota local en tu navegador supera el 85%.
              Te recomendamos descargar los archivos y limpiar la sesión.
            </span>
          ) : (
            <span>
              <strong>Sesión restaurada:</strong> Se han recuperado {restoredCount} archivos
              intactos desde tu almacenamiento privado local (OPFS).
            </span>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {restoredCount > 0 && (
          <PillButton
            label="Limpiar datos antiguos"
            variant="ghost"
            size="sm"
            onClick={onClear}
          />
        )}
        <PillButton
          label="Entendido"
          variant="outline"
          size="sm"
          onClick={onDismiss}
        />
      </div>
    </div>
  )
}
